module.exports = __webpack_public_path__ + "img/dir - 副本.ce85709a.png";